export const ClassificationMetricMapper = {
  toListItem: classificationMetric => ({
    id: classificationMetric.Id,
    classificationMetricName: classificationMetric.ClassificationMeasurementName,
    classificationNumerator: classificationMetric.ClassificationNumerator,
    classificationDenominator: classificationMetric.ClassificationDenominator,
    classificationCalculationType: classificationMetric.ClassificationCalculationType
  })
};
